import { getJSON, postJSON } from "@/lib/api"

export interface MissingTextbookPayload {
  text: string
}

export interface ContactPayload {
  subject: string
  text: string
}

export const submitFeedback = (
  type: "missing_textbook",
  payload: MissingTextbookPayload
) => postJSON("/v1/feedback", { type, payload })

export const submitContactFeedback = (payload: ContactPayload) =>
  postJSON("/v1/feedback", { type: "contact", payload })

export type StoryRating = "up" | "down"

export interface StoryRatingPayload {
  rating: StoryRating
}

interface FeedbackRow<T> {
  payload: T
  entityId: string | null
  createdAt: string
}

export const getStoryRating = async (
  storyId: string
): Promise<StoryRatingPayload | null> => {
  const rows = await getJSON<FeedbackRow<StoryRatingPayload>[]>(
    `/v1/feedback?type=story_rating&entityId=${encodeURIComponent(storyId)}`
  )
  return rows[0]?.payload ?? null
}

export const setStoryRating = (storyId: string, rating: StoryRating) =>
  postJSON("/v1/feedback", {
    type: "story_rating",
    entityId: storyId,
    payload: { rating },
  })

export interface StoryFeedbackPayload {
  reason: string
  text?: string | null
}

export const submitStoryFeedback = (
  storyId: string,
  payload: StoryFeedbackPayload
) =>
  postJSON("/v1/feedback", {
    type: "story_feedback",
    entityId: storyId,
    payload,
  })
